






























import { Vue, Component, Prop } from "vue-property-decorator";
import CallPhone from "@/pages/showDetail/CallPhone.vue";
import AdditionalDetail from './AdditionDetail.vue';
import { formatMoney } from '@/common/utils/format';

@Component({
  components: {
    "call-phone": CallPhone,
    'additional-detail': AdditionalDetail
  }
})
export default class TyTypeList extends Vue {
  @Prop({ required: true }) dataList!: Array<object>;
  @Prop({ required: true }) showDetail!: any;

  get parameter() {
    return JSON.parse(this.showDetail.parameter);
  }
  get target(): number {
    if (
      this.showDetail.templateType === "bargainType" 
    ) {
      return formatMoney(this.parameter.minPrice, 100, true);
    } else {
      return this.parameter.unitNum;
    }
  }

  get unitStr(): string {
    return this.parameter.unitStr;
  }

  get unitTitle(): string {
    return this.parameter.unitTitle;
  }
}
